import usePages, { PaginatingEndpoint } from "./use-pages";

export default function useLoadAll<T>(
  call: PaginatingEndpoint<T>,
  params: Record<string, any> = {},
  suspend = false
) {
  return usePages(call, params, Infinity, 0, suspend);
}
